import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { DesyNavModule } from 'desy-angular';
import { routes } from './app.routes';
import { httpRequestInterceptor } from './shared/interceptors/http-request/http-request.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    importProvidersFrom(BrowserModule, DesyNavModule),
    { provide: LOCALE_ID, useValue: 'es-ES' },
    provideHttpClient(withInterceptors([httpRequestInterceptor]))
  ]
};
